import React from "react";

import { usePermissions } from "./usePermissions";

/**
 * Permission gating deliberately degrades to the legacy UI when the self-permissions request fails.
 * That avoids turning a transient read failure into a portal-wide outage, but it must be visible:
 * backend authorization still applies and controls may be shown that the current account cannot use.
 */
export const PermissionLoadWarning = () => {
  const { enabled, status, error } = usePermissions();
  if (!enabled || status !== "failed") return null;

  return (
    <div
      role="alert"
      className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900"
    >
      <span className="font-semibold">Permission visibility is temporarily unavailable.</span>{" "}
      Some controls may be shown even though the backend will still enforce access.
      {error && <span className="ml-1">{error}</span>}
    </div>
  );
};

export default PermissionLoadWarning;
